<template>


	<div class="d-flex flex-column ga-4" style="min-height: 75vh" v-if="loadingMyReferrals || myReferrals.length > 0">

		<template v-if="myReferrals.length > 0">
			<MyReferralTile :user="user" v-for="user in myReferrals" :key="user.id" />
		</template>



		<template v-if="loadingMyReferrals">
			<v-skeleton-loader :elevation="4" type="list-item-avatar-three-line" v-for="n in 20" :key="n"
				color="var(--v-skeleton-loader-color)">
			</v-skeleton-loader>
		</template>

	</div>


	<EmptyList class="mx-auto mt-4" v-if="myReferrals.length === 0">
		<template v-slot:title>
			Sorry, you haven't referred anyone yet.
		</template>
	</EmptyList>



	<Pagination 
		:model-value="pageNumber"
		@update:model-value="(value) => pageNumber = value"
		:length="pageLength" 
		:total-visible="totalVisible"
	/>

</template>



<script setup>

import { computed } from "vue";
import { useUserStore } from "@/store/UserStore";
import MyReferralTile from "./MyReferral-Tile.vue";
import EmptyList from "@/components/Common/Empty-List.vue";
import Pagination from "@/components/Common/Pagination.vue";
import { usePagination } from "@/composables/usePagination";

const userStore = useUserStore();
const myReferrals = computed(() => userStore.myReferrals);
const loadingMyReferrals = computed(() => userStore.loadingMyReferrals);

// Use the pagination composable to handle pagination logic
const { pageNumber, pageLength, totalVisible } = usePagination({
	store: userStore,
	getTotalPages: (store) => store.myReferralsPaging.totalPages,
	getCurrentPage: (store) => store.myReferralsPaging.page,
	setPage: (store, page) => store.setPage(page),
	fetchData: async (store) => await store.getMyReferrals()
});
</script>


<style scoped lang="scss">
@use "@/assets/scss/button-mixins" as button-mixins;
</style>